import axios from 'axios'
import global from '@/global/variable.js'

// 获取过磅列表
export function getList(data) {
  const url = global.requestUrl + '/weighbridge/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&type=' + data.type + '&status=' + data.status + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

// 骨料水份检测
export function updateOne(data) {
  const url = global.requestUrl + '/weighbridge/moistureDetection'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}
